export enum ConfigFieldFormat {
    REACT_APP_GROUP_FILTER_PATTERN = '^[A-Z]+(?:[_-][a-zA-Z]*)*$',
    REACT_APP_EVENT_FILTER_PATTERN = '^[A-Z][a-zA-Z_]*$',
}